import * as moment from 'moment-timezone';

export const formatTimePeriodUsingSiteTimezone = (row, advancedSiteInfos) => {
  if (!row.endDate) return undefined;

  const site = advancedSiteInfos.find((x) => x.id === row.site.id);
  const timezone = site?.timezone ?? 'UTC';
  return `${moment(row.startDate).tz(timezone).format('LT')} - ${moment(row.endDate).tz(timezone).format('LT (z)')}`;
};
